import { useEffect } from "react";
import { useParams } from "react-router-dom";

/**
 * Short-link redirect: /s/{token} → /suivi-commande-topcocoon?token={token}
 * Used to generate shorter SMS-friendly tracking URLs.
 */
const ShortLinkRedirect = () => {
  const { token } = useParams();
  useEffect(() => {
    if (token) {
      window.location.replace(`/suivi-commande-topcocoon?token=${encodeURIComponent(token)}`);
    }
  }, [token]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600"></div>
    </div>
  );
};

export default ShortLinkRedirect;
